import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";
//pages & includes
import ManageSidebar from "../ManageSidebar";
//functions
import { _t, getCookie } from "../../../../../functions/Functions";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { useTranslation } from "react-i18next";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const ReasonAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();

  let {
    loading,
    setLoading,
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  // States hook here
  let [newReason, setNewReason] = useState({
    name: "",
    status: 1,
    edit: false,
    editSlug: null,
    uploading: false,
  });

  //set states on edit
  const getReasonEdit = async () => {
    try {
      const areasUrl = BASE_URL + `/settings/reason/${id}`;
      const response = await axios.get(areasUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      const locationEdit = response.data;
      setNewReason({
        ...newReason,
        name: locationEdit.name,
        status: parseInt(locationEdit.status),
        edit: true,
        editSlug: id,
      });
    } catch (error) {
      // Handle the error here
      console.error("Error fetching areas:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getReasonEdit(id);
    }
  }, [id]);

  const handleChange = (e) => {
    setNewReason({
      ...newReason,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatus=()=>{
    setNewReason({
      ...newReason,
      status:newReason.status ? 0 : 1,
    });
  }

  // reason submit
  const handleReasonAction = (e) => {
    e.preventDefault();
    if (newReason.name === "") {
      toast.error(`${_t(t("Please fill all required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } else {
      setNewReason({
        ...newReason,
        uploading: true,
      });

      const endPoint = id ? `/settings/reason/${id}` : `/settings/reason`;
      const reasonUrl = BASE_URL + endPoint;
      const method = id ? "put" : "post";
      let formData = {
        name: newReason.name,
        status: newReason.status,
      };

      return axios[method](reasonUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setNewReason({
            name: "",
            status: 1,
            edit: false,
            editSlug: null,
            uploading: false,
          });
          history.push("/dashboard/manage/restaurant/reasons");
          setLoading(false);
          setNewReason({
            ...newReason,
            uploading: false,
          });
          toast.success(`${_t(t("Reason has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch((error) => {
          setNewReason({
            ...newReason,
            uploading: false,
          });
          setLoading(false);
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    }
  };

  return (
    <div>
      <Helmet>
        <title>{_t(t("Reason"))}</title>
      </Helmet>
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newReason.uploading === true || loading === true ? (
                  tableLoading()
                  ) : ( */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader
                        loading={loading || dataPaginating || newReason.uploading}
                      />
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!newReason.edit
                                  ? _t(t("Add New Reason"))
                                  : _t(t("Update Reason"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>
                      {/* form start here */}
                      <div key="fragment-branch-1">
                        <form
                          onSubmit={handleReasonAction}
                          className="row card p-2 mx-3 mb-5 new-text-style"
                          autoComplete="off"
                        >
                          <div className="row mt-3">
                            <div className="form-group col-6">
                              <label htmlFor="zone" className="form-label">
                                {_t(t("Name"))}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="name"
                                name="name"
                                placeholder="e.g. Ordered by mistake"
                                value={newReason.name || ""}
                                required
                                onChange={handleChange}
                              />
                            </div>
                            <div className="form-group col-6" style={{marginTop: "2.2rem"}}>
                              <Switch
                               name="status"
                               height={22}
                               width={44}
                               offColor="#ee5253"
                               className="float-left"
                               checked={newReason.status}
                               onChange={handleStatus}                        
                              />
                              <label
                                className="form-check-label ml-2"
                                htmlFor="status"
                              >
                                {_t(t("Status"))}
                              </label>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="d-flex justify-content-end">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/restaurant/reasons"
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    className="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {!newReason.edit
                                    ? _t(t("Save"))
                                    : _t(t("Update"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ReasonAction;
